import {
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver, ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output, ViewChild,
  ViewEncapsulation
} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {CrudBaseComponent} from './crud-base.component';
import {CommonFieldService} from "../../services/common/common-field.service";
import {CcTableComponent} from "../table/cc-table.component";
import {CcFormDialogComponent} from "../form-dialog/cc-form-dialog.component";

@Component({
  selector: 'app-crud-table[crudService][transPartKey][fieldId][fieldName][tableConfig][formRecord]',
  templateUrl: './crud-table.component.html',
  styleUrls: ['./crud-table.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
})
export class CrudTableComponent extends CrudBaseComponent {

  // record field keys
  @Input()
  fieldName: string;

  @Input()
  fieldEnabled: string;

  @Input()
  defaultSortOrder: number = 1;

  @Input()
  defaultSortField: string;

  // table
  @Output()
  selectedRecordsChange = new EventEmitter<any>();

  @Output()
  selectionChange = new EventEmitter<any>();

  @Input()
  lazyLoadOnInit: boolean = true;

  @Input()
  reorderableRows: boolean = false;

  @Input()
  dialogClass: string;

  @Output()
  rowOrderChanged = new EventEmitter<any>();

  @Output()
  onClearTableFilter = new EventEmitter<any>();

  @Input()
  disableFilters: boolean = false;

  fieldValueMap = {};

  @ViewChild('ccFormDialog')
  public ccFormDialog: CcFormDialogComponent;

  constructor(private el: ElementRef
    , cdref: ChangeDetectorRef,
              protected componentFactoryResolver: ComponentFactoryResolver,
              protected messageService: MessageService,
              protected confirmationService: ConfirmationService,
              protected translateService: TranslateService,
              commonFieldService: CommonFieldService) {
    super(cdref, messageService, confirmationService, translateService, commonFieldService);
  }


  onRowDblClick(record: any) {
    if (!record && this.selectedRecords && this.selectedRecords.length == 1) {
      record = this.selectedRecords[0];
    }
    if (record) {
      if (!this.getIsReadOnly()) {
        this.selectedRecords = [record];
        this.edit();
      } else {
        this.formRecord = this.selectedRecords[0];
        this.showFormDialog();
      }
    }
  }

  @HostListener('document:keydown.delete', ['$event'])
  handleDeleteKeyboardEvent(event: KeyboardEvent) {
    if (this.ccTable && this.ccTable.disableSelection) return;
    if (this.ccTable && !this.ccTable.focused) return;
    // if (this.el.nativeElement.contains(event.target)) {
      if (!this.getIsReadOnly() && this.canDelete() && this.hasMultipleSelection() && !this.dialogFormVisible) {
        this.delete();
      }
    // }
  }

  private validateForm(): boolean {
    if (!this.formRecord) {
      return false;
    }
    let valid: boolean = true;
    this.formConfig.forEach(grpConfig => {
      if (!grpConfig.hidden || !grpConfig.hidden(this.formRecord)) {
        grpConfig.fields.forEach(config => {
          if (config.required
            && (!this.formRecord[config.field] || (this.formRecord[config.field] + '').length === 0)
            || (config.validate ? config.validate(this.formRecord) != '' : false)) {
            valid = false;
          }
        });
      }
    });
    return valid;
  }

  public reloadFieldValueMap(): void {
    setTimeout(() => {
      if (this.ccFormDialog)
        this.ccFormDialog.reloadFieldValueMap();
      this.fieldValueMap['validate'] = this.validateForm();
    });
    super.reloadFieldValueMap();
  }
}
